import * as faceApi from "face-api.js";

export default class FrameCompare {
  private readonly currentFrame: Blob;
  private previousFrame: Blob | null;

  constructor(currentFrame: Blob, previousFrame: Blob) {
    this.currentFrame = currentFrame;
    this.previousFrame = previousFrame;
  }

  async compare(): Promise<boolean> {
    const currentFrameImg = await faceApi.bufferToImage(this.currentFrame);
    const descriptor: any = await faceApi.computeFaceDescriptor(currentFrameImg);

    if (this.previousFrame) {
      const previousFrameImg = await faceApi.bufferToImage(this.previousFrame);
      const _previousDescriptor: any = await faceApi.computeFaceDescriptor(previousFrameImg);

      const distance = faceApi.euclideanDistance(_previousDescriptor, descriptor);

      if (distance < 0.4) {
        this.previousFrame = null;

        return Promise.resolve(true);
      }
    }

    return Promise.resolve(false);
  }
}
